import React, { useEffect, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Heading } from '@thd-olt-component-react/heading';
import { Card } from '@thd-olt-component-react/card';
import './shop-by-category.scss';
import data from '../../docs/assets/shop-by-category.json';

const ShopByCategory = () => {
  const title = 'Shop By Category';
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('shop-by-category.ready');
  }, []);

  const categoryList = data.CategoryData;

  const buildCategoryGrid = () => {
    return (
      (categoryList || []).map((category) => (
        <div className="shop-by-category__category col__4-12 col__2-12--sm">
          <a
            className="shop-by-category__category-link"
            href={category.link}
            title={category.title}
          >
            <div className="shop-by-category__category-wrapper">
              <span className="">
                <img
                  src={category.imageURL}
                  className="stretchy"
                  alt={category.title}
                  title={category.title}
                />
              </span>
            </div>
          </a>
          <div className="shop-by-category__category-title">
            <div className="shop-by-category__category-text">
              {category.title}
            </div>
          </div>
        </div>
      ))
    );
  };

  return (
    <div className="shop-by-category">
      <div className="grid shop-by-category">
        <div className="col__12-12">
          { !isMobile && (
            <>
              <Heading underline title={title} />
              <div className="shop-by-category__content">
                {buildCategoryGrid()}
              </div>
            </>
          )}
          { isMobile && (
            <Card noHide>
              <Card.Content className="shop-by-category__card" title={title} maxHeight="none">
                <div className="shop-by-category__content">
                  {buildCategoryGrid()}
                </div>
              </Card.Content>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
};

ShopByCategory.displayName = 'ShopByCategory';

export { ShopByCategory };
